import { setPlatformHelpers } from "@stencil/core";
import { productIcons } from "./productIconList";
import toast from "./commands/toast";
window.RAUL = {
    version: "RAUL_VERSION",
    commands: {
        toast,
    },
    misc: {
        productIcons,
    },
};
export const initialize = (config = {}) => {
    const platformHelpers = {};
    if (config._ael) {
        platformHelpers.ael = config._ael;
    }
    if (config._rel) {
        platformHelpers.rel = config._rel;
    }
    if (config._ce) {
        platformHelpers.ce = config._ce;
    }
    setPlatformHelpers(platformHelpers);
};
export default initialize;
//# sourceMappingURL=index.js.map
